import CancellableHelper from "@/requests/CancellableHelper";
import GetCashReportsDataTableResponse from "@/models/api/finances/GetCashReportsDataTableResponse";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { AddCashReportRequest } from "@/models/api/finances/AddCashReportRequest";
import { axiosInstance } from "@/plugins/axios";

export const URL_GET_CASH_REPORTS = "/cashReport/${CashboxId}/Paged";
export const URL_POST_ADD_CASH_REPORT = "/cashReport/Add";
export const URL_POST_REMOVE_CASH_REPORT = "/cashReport/${CashReportId}/Remove";
export const URL_POST_REPRINT_CASH_REPORT = "/cashReport/${CashReportId}/Print";
export const URL_GET_SHOW_CASH_REPORT = "/cashReport/${CashReportId}/Show";

const _getCashReportsDataTable = new CancellableHelper<GetCashReportsDataTableResponse>(
  URL_GET_CASH_REPORTS,
  GetCashReportsDataTableResponse
);
_getCashReportsDataTable.jsonSerializer = true;
export const getCashReportsDataTable = async (
  genericTableRequest: GenericTableRequest,
  cashboxId: number
): Promise<GetCashReportsDataTableResponse> => {
  _getCashReportsDataTable.url = URL_GET_CASH_REPORTS.replace("${CashboxId}", cashboxId.toString());
  return await _getCashReportsDataTable.get(genericTableRequest);
};

const _postAddCashReport = new CancellableHelper<number>(URL_POST_ADD_CASH_REPORT, "number");
export const postAddCashReport = async (request: AddCashReportRequest): Promise<number> => {
  return await _postAddCashReport.post({}, request);
};

const _postRemoveCashReport = new CancellableHelper<null>(URL_POST_REMOVE_CASH_REPORT);
export const postRemoveCashReport = async (cashReportId: number): Promise<null> => {
  return await _postRemoveCashReport.post({ CashReportId: cashReportId }, null);
};

const _postReprintCashReport = new CancellableHelper<null>(URL_POST_REPRINT_CASH_REPORT);
export const postReprintCashReport = async (cashReportId: number): Promise<null> => {
  return await _postReprintCashReport.post({ CashReportId: cashReportId }, null);
};

export const showCashReport = async (cashReportId: number): Promise<void> => {
  const response = await axiosInstance.get(
    URL_GET_SHOW_CASH_REPORT.replace("${CashReportId}", cashReportId.toString()),
    {
      responseType: "blob",
    }
  );
  const blob = new Blob([response.data], {
    type: response.headers["content-type"],
  });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.target = "_blank";
  link.click();
};
